import React from "react";
import PropTypes from "prop-types";
import BlanketBasicInformationBase from "./BlanketBasicInformationBase";
import { BLANKET_BASIC_INFO_CONFIG } from "./blanketBasicInformationConfig";
import { GoogleAutoComplete } from "../../shared/widgets";

export default function BasicInformation(props) {
  return (
    <BlanketBasicInformationBase
      config={{
        ...BLANKET_BASIC_INFO_CONFIG.creation,
        GoogleAutoCompleteComponent: GoogleAutoComplete,
      }}
      {...props}
    />
  );
}

BasicInformation.propTypes = {
  control: PropTypes.object.isRequired,
  errors: PropTypes.object,
  watch: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  loadingCounties: PropTypes.bool,
  allCounties: PropTypes.array,
  allCities: PropTypes.array,
  allStates: PropTypes.array,
  otherResidency: PropTypes.bool,
  handleOtherResidencyChange: PropTypes.func.isRequired,
  emailExists: PropTypes.bool,
  emailChecking: PropTypes.bool,
  emailDialogOpen: PropTypes.bool,
  handleDialogClose: PropTypes.func.isRequired,
  handleDialogContinue: PropTypes.func.isRequired,
  handleDialogCancel: PropTypes.func.isRequired,
  handleEmailFieldChange: PropTypes.func.isRequired,
  handleGoogleCallback: PropTypes.func.isRequired,
};
